import { Link, NavLink } from "react-router";
import {
  ArrowLeftRight,
  CalendarClock,
  CalendarDays,
  FileBarChart2,
  LayoutDashboard,
  Plug,
} from "lucide-react";
import { BrandMark } from "@/components/brand-mark";
import { SidebarUserFooter } from "@/components/nav/sidebar-user-footer";
import { cn } from "@/lib/cn";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/conferences", label: "Conferences", icon: CalendarDays },
  { to: "/upcoming", label: "Upcoming Events", icon: CalendarClock },
  { to: "/streams", label: "Sync Streams", icon: ArrowLeftRight },
  { to: "/integrations", label: "Integrations", icon: Plug },
  { to: "/reports", label: "Reports", icon: FileBarChart2 },
] as const;

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "flex items-center gap-3 rounded-rs-sm px-3 py-2 text-sm font-medium text-rs-ink-muted hover:bg-rs-muted hover:text-rs-ink",
    isActive && "bg-rs-accent-soft text-rs-accent-ink",
  );

export function WorkspaceSidebar({ compact }: { compact?: boolean }) {
  return (
    <aside
      className={cn(
        "rs-workspace-sidebar flex h-full flex-col border-r border-rs-border bg-rs-sidebar",
        compact ? "w-16" : "w-60",
      )}
    >
      <Link
        to="/"
        className="text-inherit no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rs-info"
        aria-label="AttendeeSync Dashboard"
      >
        <BrandMark showIcon={false} />
      </Link>
      <nav
        className="flex-1 space-y-1 overflow-y-auto p-2"
        aria-label="Workspace"
      >
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={"end" in item ? item.end : undefined}
            className={navLinkClass}
          >
            <item.icon className="h-4 w-4 shrink-0" aria-hidden />
            {!compact ? (
              item.label
            ) : (
              <span className="sr-only">{item.label}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <SidebarUserFooter />
    </aside>
  );
}
